import { ChangeEvent, useEffect } from "react";
import { useFormContext } from "react-hook-form";

import { Checkbox } from "chameleon/lib/components";

import { usePaymentOptionContext } from "checkout-experience/components/payment-method/payment-option-provider";

interface Props {
  id: string;
  title: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  value?: string;
}
const fieldName = "collectConsentToStoreForFuturePaymentsText";
// new field to get the consent text and pass it in the formFields.
export const FormConsentCheckbox = (props: Props) => {
  const { id, title, onChange, value } = props;
  const { register, setValue } = useFormContext();
  const { paymentOption } = usePaymentOptionContext() ?? {};
  const { formId } = paymentOption ?? {};
  useEffect(() => {
    register(`${formId}.${fieldName}`, {
      value: "",
    });
  }, []);
  const handleOnchange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setValue(`${formId}.${fieldName}`, title);
    } else {
      setValue(`${formId}.${fieldName}`, "");
    }
    onChange(e);
  };

  return (
    <Checkbox
      id={id}
      onChange={handleOnchange}
      content={title}
      isChecked={value === "true"}
    />
  );
};
